(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name adminCrewBatchers.factory:CrewBatchFactory
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .factory('ManageCrewFactory',ManageCrewFactory);

    function ManageCrewFactory(AuthService) {

        function SearchCriteriaDTO() {
            this.loginId = null;
            this.displayName = null;
			this.userType = null;
			this.status = null;
            this.pageSize = null;
            this.startPosition = null;
        }

        function AdminRoleDTO() {
        	this.roleName = null,
        	this.visibleRolesOnly = "true",
        	this.pageSize = 1000,
        	this.startPosition = 1
        }

        function CrewSearchDTO(){
        	this.crewType = null;
        }

        function CrewDTO(){
        	this.crewProfileId = null;
        	this.crewId = null;
        	this.firstName = null;
        	this.lastName = null;
        	this.dob = null;
        	this.dateOfJoin = null;
        	this.dateOfContract = null;
        	this.crewType = null;
        	this.fullName = null;
        }

		function UserDTO() {
			this.loginId = null;
			this.displayName = null;
			this.crewTypeCode = null;
			this.crewId = null;
			this.userType = null;
			this.crewName = null;
			this.password = null;
			this.status = null;
			this.roles = [];
			this.oldLoginId = null;
			this.msgRecipients = [];
			this.version = null;
			this.passwordChanged = false;
			this.iv = null;
			this.ciphertext = null;
			this.salt = null;
			this.email = null;
      this.airports = [];
      this.singleSignOn = null;
		}

		function UserTypeDTO(){
			this.userTypeCode = null;
			this.userTypeDescription = null;
		}


		function CrewTypeDTO(){
			this.crewTypeCode = null;
			this.crewTypeDescription = null;

		}

		function PasswordDTO(){
			this.actual = null;
			this.conf =null;
		}

		function StatusDTO(){
			this.status = null;
			this.statusCode = null;
		}

		function RoleDTO(){
			this.roleId = null;
		}

    function AirportDTO(){
          this.airportCode = null;
    }

		function GetNewUser() {
			var user = new UserDTO();
			user.version = -1;
			user.userType = new UserTypeDTO();

			var status = new StatusDTO();
    		status.statusCode = "ACT";
    		status.status = false ;
    		user.status = status;

			var userType = new UserTypeDTO();
			user.userType = userType;

			var crewType = new CrewTypeDTO();
			user.crewTypeCode = crewType;

			var password = new PasswordDTO();
			user.password = password;

      user.singleSignOn =  false;

			return user;
		}

        function GetUserSearchRequest() {
            return new SearchCriteriaDTO() ;
        }

        function GetRoleSearchRequest(){
        	   return new AdminRoleDTO() ;
        }

        function GetUserNameByCrewTypeRequest(params){
        	var crew = new CrewSearchDTO();
        	crew.crewType = params.crewTypeCode;
        	return crew;
        }

        function FormatCrewSearchResponse(userList){
        	var formattedList = [];
        	 angular.forEach(userList, function (user) {
        		 var crew = new CrewDTO();
        		 crew.crewProfileId = user.crewProfileId;
        		 crew.crewId = user.crewId;
        		 crew.firstName = user.firstName;
        		 crew.lastName =  user.firstName;
        		 crew.dob = user.dob;
        		 crew.dateOfJoin = user.dateOfJoin;
        		 crew.dateOfContract = user.dateOfContract;
        		 crew.crewType = user.crewType;
        		 crew.statusCode = user.status;
        		 crew.fullName =  user.firstName + " " + user.lastName;

        		 formattedList.push(crew);
             });

        	 return formattedList;
        }


        function FormatUserSearchResponse(userList){
        	var formattedList = [];
        	angular.forEach(userList, function (user) {
        		 var userdto = new UserDTO();
        		 userdto.loginId = user.loginId;
        		 userdto.oldLoginId = user.loginId;
        		 userdto.displayName = user.displayName;
        		 userdto.crewName = user.crewName.trim();
        		 userdto.crewId = user.crewId;
        		 userdto.roles = user.roles;
        		 userdto.msgRecipients = user.msgRecipients;
        		 userdto.version = user.version;
        		 userdto.email = user.email;
             userdto.airports = user.airports;
             userdto.singleSignOn = user.singleSignOn === "N";

        		 var status = new StatusDTO();
        		 status.statusCode = user.status;
        		 status.status = ( user.status == "INA" ) ? true : false ;
        		 userdto.status = status;

        		 var userType = new UserTypeDTO();
        		 userType.userTypeCode = user.userType;
        		 userdto.userType = userType;

        		 var crewType = new CrewTypeDTO();
        		 crewType.crewTypeCode = user.crewTypeCode;
        		 userdto.crewTypeCode = crewType;

        		 userdto.password = userdto.singleSignOn ? PopulateDummyPassword(user.passwordCharCount) : new PasswordDTO();

        		 formattedList.push(userdto);
             });

        	 return formattedList;
        }

        function FormatUserTypeResponse(userTypes){
	         var formattedList = [];
	       	 angular.forEach(userTypes, function (userType) {
		       	 var userTypeDTO = new UserTypeDTO();
		       	 userTypeDTO.userTypeCode = userType.userTypeCode;
		       	 userTypeDTO.userTypeDescription = userType.userTypeDescription;
		       	 formattedList.push(userTypeDTO);
	            });

	       	 return formattedList;
        }


       function FormatCrewTypeResponse(crewTypes){
    	   var formattedList = [];
	       angular.forEach(crewTypes, function (crewType) {
		        var crewTypeDTO = new CrewTypeDTO();

		       	crewTypeDTO.crewTypeCode = crewType.crewTypeCode;
		       	crewTypeDTO.crewTypeDescription = crewType.crewTypeDescription;

		       	formattedList.push(crewTypeDTO);
	       });

	       return formattedList;
       }

       function FormatAirportListResponse(airports){
         var formattedList = [];
         angular.forEach(airports, function (airport) {
           var airportDTO = new AirportDTO();
           airportDTO.airportCode = airport.airPortCode;
           formattedList.push(airportDTO);
         });
         return formattedList;
       }

       function PopulateDummyPassword(charCount){

    	   var dummyPassword = "Dmy@1234";
    	   charCount = charCount-dummyPassword.length;

    	   for(var i=0 ; i<charCount ; i++){
    		   dummyPassword += "x";
    	   }

    	   var password = new PasswordDTO();
    	   password.actual = dummyPassword;
    	   password.conf = dummyPassword;

    	   return password;
       }


	   function UserGridRowToUserDTO(selectedRow) {
			var userdto = new UserDTO();
			userdto.loginId = selectedRow.loginId;
			userdto.oldLoginId = selectedRow.oldLoginId;
			userdto.displayName = selectedRow.displayName;
			userdto.crewName = selectedRow.crewName;
			userdto.roles = selectedRow.roles;
			userdto.msgRecipients = selectedRow.msgRecipients;
			userdto.version = selectedRow.version;
			userdto.crewId = selectedRow.crewId;
			userdto.email = selectedRow.email;
      userdto.airports = selectedRow.airports;
      userdto.singleSignOn = selectedRow.singleSignOn;

			var status = new StatusDTO();
    		status.status = selectedRow.status.status;
    		status.statusCode = selectedRow.status.statusCode;
    		userdto.status = status;

    		userdto.crewName = selectedRow.crewName;

			var userType = new UserTypeDTO();
			userType = selectedRow.userType;
			userdto.userType = userType;

			if(selectedRow.crewTypeCode.crewTypeCode != null){
				var crewType = new CrewTypeDTO();
				crewType = selectedRow.crewTypeCode;
				userdto.crewTypeCode = crewType;
			}

			var password = new PasswordDTO();
			password.actual = selectedRow.password.actual;
			password.conf = selectedRow.password.conf;
			userdto.password = password;

			return userdto;
		}

	   function PopulatePassword(userName,password){
		  var encriptedData = AuthService.getCrewProfileChangePasswordRequest(userName,password);
		  return encriptedData;
	   }

	    function PopulateUserDeleteRequest(params){
	    	var userDeleteRequest = new SearchCriteriaDTO();
	    	userDeleteRequest.loginId = params.loginId;
	    	userDeleteRequest.version = params.version;
	    	return userDeleteRequest;
	    }

	    function PopulateSaveUserRequest(params,masterData){
	    	var saveUserRequest = new UserDTO();
	    	saveUserRequest.loginId = params.loginId;
	    	saveUserRequest.oldLoginId = params.oldLoginId;
	    	saveUserRequest.version = params.version;
	    	saveUserRequest.displayName = params.displayName;
	    	saveUserRequest.status = params.status.status ? "INA" : "ACT" ;
	    	saveUserRequest.crewTypeCode = params.crewTypeCode != null ? params.crewTypeCode.crewTypeCode : null;
        saveUserRequest.crewId	=  getCrewIdFromParams(params);
	    	saveUserRequest.passwordChanged = params.passwordChanged;
	    	saveUserRequest.email = params.email;
        saveUserRequest.singleSignOn = !params.singleSignOn ? "Y" : "N" ;

	    	if(params.passwordChanged){
	    		var encriptedData = PopulatePassword(params.oldLoginId,params.password.actual);
	    		saveUserRequest.iv = encriptedData.iv;
	    		saveUserRequest.ciphertext = encriptedData.ciphertext
	    		saveUserRequest.salt = encriptedData.salt
	    	}


	    	angular.forEach(masterData.userTypes, function (userType) {
	    		if(userType.userTypeDescription == params.userType.userTypeDescription){
	    			saveUserRequest.userType = userType.userTypeCode;
	    		}
	        });


	    	if(params.msgRecipients != null){
	    		var msgRecipients = [];
	    		angular.forEach(params.msgRecipients, function (msgres) {
			       	var crewTypeDTO = new CrewTypeDTO();
			       	crewTypeDTO.crewTypeCode = msgres.crewTypeCode;
			       	msgRecipients.push(crewTypeDTO);
		        });

	    		saveUserRequest.msgRecipients = msgRecipients;
	    	}

	    	if(params.roles != null){
	    		var roles = [];
	    		angular.forEach(params.roles, function (role) {
			       	var roleDTO = new RoleDTO();
			       	roleDTO.roleId = role.roleId;
			       	roles.push(roleDTO);
		        });

	    		saveUserRequest.roles = roles;
	    	}

        if(params.airports != null){
          var airports = [];
          angular.forEach(params.airports, function (airport) {
            var airportDTO = new AirportDTO();
            airportDTO.airportCode = airport.airportCode;
            airports.push(airportDTO);
          });
          saveUserRequest.airports = airports;
        }

	    	return saveUserRequest;
	    }

	    function getCrewIdFromParams(params) {
	      if(params.crewName === null || angular.isUndefined(params.crewName)){
	        return null;
        }

        if(!angular.isUndefined(params.crewName.crewProfileId)){
	        return params.crewName.crewProfileId;
        }

        return params.crewId;
      }

        return {
              getUserSearchRequest: GetUserSearchRequest,
              getNewUser : GetNewUser,
              getRoleSearchRequest : GetRoleSearchRequest,
              getSearchUserByCrewTypeRequest : GetUserNameByCrewTypeRequest,
              formatCrewSearchResponse : FormatCrewSearchResponse,
              formatUserSearchResponse: FormatUserSearchResponse,
              formatUserTypeResponse : FormatUserTypeResponse,
              formatCrewTypeResponse : FormatCrewTypeResponse,
              userGridRowToUserDTO : UserGridRowToUserDTO,
              populateUserDeleteRequest:PopulateUserDeleteRequest,
              populateSaveUserRequest : PopulateSaveUserRequest,
              formatAirportListResponse : FormatAirportListResponse
        }
    }
})();
